import { TweenLite } from 'gsap/TweenLite';

export default function fade(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = TweenLite.set(elToTween, {
    autoAlpha: 0,
  });

  return tween;
}
